import axios from 'axios';

//https://localhost:44312
const resolveBaseURL = () => {
  try {
    const { hostname, origin } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    // fallback to same-origin when deployed under same host
    return origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClientGroups = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientGroups.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClientGroups.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default httpClientGroups;

export const resolveGroupsAssetUrl = (path) => {
  if (!path) return '';
  if (typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL();
  return `${base}${path}`;
};


